export default {
  body: {
    width: '100%',
    margin: '0',
    fontFamily: 'Circular-Book, Helvetica, Arial, sans-serif',
    fontWeight: 300,
  },
};
